import { useState } from 'react';
import { PublicImage, ResponsiveImage } from '../../fileStorage/ResponsiveImage';
import { catalogImageUrl } from './catalogDisplay';

export function CatalogPhoto({ fileId, name, image, sizes = '(max-width: 640px) 90vw, 400px' }: { fileId?: number; name: string; image?: PublicImage | null; sizes?: string }) {
  const imageKey = `${fileId}:${image?.active_version ?? image?.variants[0]?.url ?? 'legacy'}`;
  const [failedId, setFailedId] = useState<string>();
  const [loadedId, setLoadedId] = useState<string>();
  const [attempt, setAttempt] = useState(0);
  const retry = (): void => {
    setFailedId(undefined);
    setAttempt((currentAttempt) => currentAttempt + 1);
  };

  if (fileId === undefined || failedId === imageKey) {
    return (
      <div className="catalog-photo-empty">
        <span aria-hidden="true">Фото</span>
        <p>{fileId === undefined ? 'Фотография ещё не добавлена' : 'Не удалось открыть фотографию'}</p>
        {fileId !== undefined && name !== '' ? <button className="catalog-button" type="button" onClick={retry}>Повторить</button> : null}
      </div>
    );
  }

  const url = catalogImageUrl(fileId);
  return (
    <div className="catalog-photo-frame">
      {loadedId !== imageKey ? <span className="catalog-photo-loading">Загружаем фото…</span> : null}
      <ResponsiveImage image={image} sizes={sizes} className="catalog-photo" key={`${imageKey}-${attempt}`} alt={name} fallbackSrc={url} onLoad={() => setLoadedId(imageKey)} onError={() => setFailedId(imageKey)} />
    </div>
  );
}
